import {Injectable} from '@angular/core';
import {Action, Store} from '@ngrx/store';
import {Actions, concatLatestFrom, createEffect, ofType} from '@ngrx/effects';
import {map} from 'rxjs/operators';
import {aktualizujZbiorUszkodzen, usunUszkodzenie, usunZbiorUszkodzen} from './zbiorUszkodzen.actions';
import {aktualizujZbiorUszkodzenPrzedmiotow, usunZbiorUszkodzenPrzedmiotow} from '../zbior-uszkodzen-przedmioty/zbiorUszkodzenPrzedmiotu.actions';
import {selectZbiorUszkodzenById} from './zbiorUszkodzen.selectors';
import {brakOperacjiAction} from '../actions';

@Injectable()
export class ZbiorUszkodzenEffects {

  constructor(private store: Store,
              private actions$: Actions) {
  }

  aktualizujZbiorUszkodzen$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(aktualizujZbiorUszkodzen),
        map(({przedmiotId, zbiorUszkodzen}) => {
          return aktualizujZbiorUszkodzenPrzedmiotow({
            przedmiotId,
            zbiorUszkodzenId: zbiorUszkodzen.id
          })
        })
      )
  );

  usunZbiorUszkodzen$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(usunZbiorUszkodzen),
        map(({przedmiotId, id}) => {
          return usunZbiorUszkodzenPrzedmiotow({
            przedmiotId,
            zbiorUszkodzenId: id
          })
        })
      )
  );

  // dla aktualizujUszkodzenie brak akcji

  usunUszkodzenie$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(usunUszkodzenie),
        concatLatestFrom((action) => {
          return this.store.select(selectZbiorUszkodzenById, action.id)
        }),
        map(([action, zbiorUszkodzen]) => {
          let resultAction: Action;
          if (zbiorUszkodzen === undefined) {
            resultAction = usunZbiorUszkodzenPrzedmiotow({
              przedmiotId: action.przedmiotId,
              zbiorUszkodzenId: action.id
            });
          } else {
            resultAction = brakOperacjiAction();
          }
          return resultAction;
        })
      )
  );
}
